import React from 'react';
import PropTypes from 'prop-types';
import Actions from 'components/ui/general/Actions';
import Breadcrumbs from 'components/layout/Layout/Breadcrumbs';
import Card from 'components/ui/card/Card';
import CardText from 'components/ui/card/CardText';
import Header from 'components/ui/general/Header';
import ListButton from 'components/button/ListButton';
import Title from 'components/ui/general/Title';
import compose from 'recompose/compose';
import translate from 'components/hoc/translate';
import { connect } from 'react-redux';
import MembershipPoolCreateForm from './MembershipPoolCreateForm';
import { createMembershipPool } from 'store/actions/membership-pools/createMembershipPools';

const MembershipPoolCreateContainer = ({ translate, history, dispatchForm }) => {
    const handleSubmitForm = (values) => {
        return new Promise((resolve) => {
            dispatchForm({
                onError: resolve,
                onSuccess: () => {
                    resolve(history.push('/membership-pools'));
                },
                values: values,
            });
        });
    };

    const breadcrumbs = [
        {
            label: translate('menu.sidebar.membership_pools'),
            link: '/membership-pools',
        },
        {
            label: translate('actions.create'),
        },
    ];

    return (
        <div>
            <Breadcrumbs breadcrumbs={ breadcrumbs } />

            <Header>
                <Title title={ translate('actions.create') } />

                <Actions>
                    <ListButton url='/membership-pools' />
                </Actions>
            </Header>

            <Card>
                <CardText>
                    <MembershipPoolCreateForm
                        form='membership-schedule'
                        handleSubmitForm={ handleSubmitForm }
                        initialValues={ {
                            name: null,
                            size: null,
                            is_default: false,
                        } }
                    />
                </CardText>
            </Card>
        </div>
    );
};

MembershipPoolCreateContainer.propTypes = {
    dispatchForm: PropTypes.func.isRequired,
    history: PropTypes.object.isRequired,
    translate: PropTypes.func.isRequired,
};

const mapDispatchToProps = (dispatch) => {
    return {
        dispatchForm: (values) => {
            dispatch(createMembershipPool(values));
        },
    };
};

const enhance = compose(
    connect(
        null,
        mapDispatchToProps,
    ),
    translate,
);

export default enhance(MembershipPoolCreateContainer);



// WEBPACK FOOTER //
// ./src/pages/membership-pools/create/MembershipPoolCreateContainer.js